import React from "react";
import {AvForm, AvField} from 'availity-reactstrap-validation';
import {Alert, Button, Col, Container, Row, Table} from "reactstrap";

import NavBar from "components/S*_Navbar.js";
import Support from 'components/S3_Support.js';
import Footer from "components/SL_Footer.js";
import CaptchaChallenge, {useCaptcha} from "components/CaptchaChallenge.js";

import {fetchData, postMaintenanceSubscription} from '../api/';
import {getApiErrorMessage} from '../api/errors';

export default () => {
  const [data, setData] = React.useState();
  const [status, setStatus] = React.useState();
  const [errors, setErrors] = React.useState([]);
  const captcha = useCaptcha();
  const homeLinkPrefix = "/";

  React.useEffect(() => {
    const fetch = async () => setData(await fetchData());
    fetch();
  }, []);

  React.useEffect(() => {
    document.title = "EDIfly | Support and Maintenance";
  }, []);

  const completeData = data || {
    downloads: {'Product Briefing': [], 'Whitepapers': [], 'FAQ + Case Studies': []},
    scheduled_maintenances: []
  };
  const scheduledMaintenances = [...(completeData.scheduled_maintenances || [])].sort((first, second) => {
    const firstDateTime = new Date(`${first.date} ${first.time}`);
    const secondDateTime = new Date(`${second.date} ${second.time}`);

    return secondDateTime - firstDateTime;
  });

  const handleValidSubmit = async (_, values) => {
    const recaptchaToken = await captcha.execute('maintenance_subscription');
    if (!recaptchaToken) return;

    setStatus('submitting');
    setErrors([]);

    try {
      await postMaintenanceSubscription({
        ...values,
        recaptcha_token: recaptchaToken,
        recaptcha_action: 'maintenance_subscription'
      });
      setStatus('success');
    } catch (error) {
      setErrors([getApiErrorMessage(error, 'Unable to subscribe to maintenance emails.')]);
      setStatus('error');
    }
  };

  return (
    <>
      <NavBar linkPrefix={homeLinkPrefix} showLogo />

      <section className="text-center" style={{paddingTop: '95px', paddingBottom: '0'}}>
        <Container>
          <h1 className="title" style={{marginBottom: '10px'}}>Support and Maintenance</h1>
        </Container>
      </section>

      <section className="section section-light" id="scheduled-maintenance" style={{paddingTop: '15px'}}>
        <Container>
          <h2 className="title text-center" style={{marginBottom: '25px'}}>Scheduled Maintenances</h2>
          {scheduledMaintenances.length > 0 ? (
            <Table responsive striped>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Length</th>
                </tr>
              </thead>
              <tbody>
                {scheduledMaintenances.map((maintenance, index) => (
                  <tr key={index}>
                    <td>{maintenance.date}</td>
                    <td>{maintenance.time}</td>
                    <td>{maintenance.length}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p className="text-center">No scheduled maintenances.</p>
          )}
        </Container>
      </section>

      <Support data={completeData} />

      <section className="section" id="maintenance-subscription">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <h2 className="title text-center">Subscribe to Maintenance Emails</h2>
              {status === 'success' ? (
                <Alert color="success">Subscription request sent.</Alert>
              ) : (
                <AvForm onValidSubmit={handleValidSubmit}>
                  <Row>
                    <Col md={6}>
                      <AvField label="Name" placeholder="Jane Doe" type="text" name="name" required />
                    </Col>
                    <Col md={6}>
                      <AvField label="Company" placeholder="Example Ltd" type="text" name="company" required />
                    </Col>
                  </Row>

                  <AvField label="Email Address" placeholder="jane@example.com" type="email" name="email" required />
                  <CaptchaChallenge captcha={captcha} />

                  <div className="text-center">
                    <Button color="success" size="lg" type="submit" disabled={status === 'submitting'}>
                      {status === 'submitting' ? 'Submitting...' : 'Subscribe'}
                    </Button>
                  </div>

                  {status === 'error' && errors.length > 0 && (
                    <div className="text-danger text-center mt-3">
                      {errors.map((error, index) => (
                        <p className="mb-0" key={index}>{error}</p>
                      ))}
                    </div>
                  )}
                </AvForm>
              )}
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
}
